export const calculateProfit = (trade) => {
  const { entryPrice, takeProfit, stopLoss, lotSize, entryType, outcome } =
    trade;

  // Convert prices to numbers
  const entry = parseFloat(entryPrice);
  const tp = parseFloat(takeProfit);
  const sl = parseFloat(stopLoss);
  const size = parseFloat(lotSize);

  // Calculate pip value (1 pip = 0.01)
  const getPipValue = (price1, price2) => {
    return Math.abs(price1 - price2) * 100; // Convert price difference to pips
  };

  if (entryType === "buy") {
    if (outcome === "tp") {
      // Winning long trade: (TP - Entry) × 100 × lotSize
      return getPipValue(tp, entry) * size;
    } else {
      // Losing long trade: (SL - Entry) × 100 × lotSize
      return -(getPipValue(entry, sl) * size);
    }
  } else {
    // sell trade
    if (outcome === "tp") {
      // Winning short trade: (Entry - TP) × 100 × lotSize
      return getPipValue(entry, tp) * size;
    } else {
      // Losing short trade: (Entry - SL) × 100 × lotSize
      return -(getPipValue(sl, entry) * size);
    }
  }
};
